import { ReactNode } from 'react';

import { AccountFlagEnum } from '~/generated/graphql';
import useFeatureFlag from '~/hooks/account/useFeatureFlag';

type WhenTargetMarkets = {
  children: ReactNode;
  cta?: ReactNode;
};
/**
 * A component which reveals UI for users that have access to TargetMarkets.
 * If a user doesn't have access to TargetMarkets, it can optionally display a CTA.
 *
 * @example
 * <WhenTargetMarkets>
 *  <div>Target Markets, folks!</div>
 * </WhenTargetMarkets>
 *
 * @param {ReactNode} children the UI to reveal if the user has access to TargetMarkets
 * @param {ReactNode} cta optional CTA to display if the user doesn't have access to TargetMarkets
 * @returns {ReactNode | null} rendered children if the user has TargetMarkets access
 */
export function WhenTargetMarkets({ children, cta = null }: WhenTargetMarkets) {
  const canAccessTargetMarkets = useFeatureFlag(
    AccountFlagEnum.RolloutPlatformWvrIcpUi,
  ).enabled;

  if (canAccessTargetMarkets) {
    return <>{children}</>;
  }

  return <>{cta}</>;
}
